import {FIRST_LAYER_PATHS, ROUTES} from '../constants'

export function isFirstLayerPage(pathname: string): boolean {
  const path = getCurrentUrl(pathname).replace(/\/$/, '') || '/'

  if (FIRST_LAYER_PATHS.includes(path)) {
    return true
  }

  if (path.startsWith(`${ROUTES.SETTINGS.BASE}/`)) {
    const relative = path.slice(ROUTES.SETTINGS.BASE.length + 1)
    return relative.length > 0 && !relative.includes('/')
  }

  return false
}

export function checkIsActive(pathname: string, url: any) {
  if (typeof url !== 'string') {
    return false
  }
  url = url.split('?')[0]
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  return isDirectChild(url, current)
}

export function checkIsActiveSubRoute(subRoute: Array<string>, pathname: any) {
  if (typeof pathname !== 'string' || !Array.isArray(subRoute)) {
    return false
  }
  const current = getCurrentUrl(pathname)
  if (!current || subRoute.length === 0) {
    return false
  }

  if (subRoute.indexOf(current) > -1) {
    return true
  }

  for (const route of subRoute) {
    if (isDirectChild(route, current)) {
      return true
    }
  }
}

export const getFilteredSearchParams = (
  searchParams: URLSearchParams,
  excludeKeys: string[] = []
): string => {
  return [...searchParams.entries()]
    .filter(([key]) => !excludeKeys.includes(key))
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
}

function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

function isDirectChild(parentPath: string, childPath: string): boolean {
  if (!parentPath || !childPath) {
    return false
  }

  // Remove query parameters and hash fragments
  parentPath = getCurrentUrl(parentPath)
  childPath = getCurrentUrl(childPath)

  // Ensure that childPath starts with parentPath and has exactly one additional segment
  return (
    childPath.startsWith(parentPath) &&
    childPath.split('/').length === parentPath.split('/').length + 1
  )
}
